// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ModalSorry_wrap__3sGtV","body":"ModalSorry_body__Sx1bR","footer":"ModalSorry_footer__2pQL0","btn":"ModalSorry_btn__2K-9N"};